import React, { useState, useEffect } from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import "./App.css";
import MainProvider from "./providers/mainProvider";
import MainSwitch from "./routes/mainSwitch";
import { GlobalStyles } from "./theme/globalStyle";
import theme from "./theme/schema.json";
import { DATA_REFERENCE } from "./utils/Constants";

function App() {
  const [isRerender, setIsRerender] = useState(false);
  useEffect(() => {
    function handleEvent(message) {
      alert(message.data);
      const data = message.data;
      localStorage.setItem(DATA_REFERENCE, data);
      setIsRerender(!isRerender);
    }
    document.addEventListener("message", handleEvent);

    return () => document.removeEventListener("message", handleEvent);
  }, [isRerender]);

  return (
    <MainProvider>
      <StyledThemeProvider theme={theme.data}>
        <GlobalStyles />
        <MainSwitch />
      </StyledThemeProvider>
    </MainProvider>
  );
}

export default App;
